(()=>{
  
  const section = document.getElementById('MainFaq');
  
  if (!section) return;
  
  const nav = section.querySelector('.faq-nav__list');
  
  const groups = section.querySelectorAll('.faq-group');
  if (groups) {
    groups.forEach((group)=>{
      
      // get the group heading text
      let linkText = 'Section'
      const heading = group.querySelector('.faq-group__title');
      if (heading && heading.innerText + '') {
        linkText = heading.innerText;
      }
      
      // create the link
      const a = document.createElement("a");
      a.href = '#' + group.getAttribute('id');
      a.classList.add('faq-nav__link', 'sh', 'no-margin');
      a.innerText = linkText;
      
      // add to the nav
      nav.append(a);
      
    });
  }
  
})();